const variants = {
  icon: '/brand/braincamp-icon.png',
  fullLight: '/brand/braincamp-logo-light.png',
  fullDark: '/brand/braincamp-logo-dark.jpeg',
}

export default function BrandLogo({
  variant = 'fullLight',
  src,
  alt = 'BrainCamp Technologies',
  className = '',
}) {
  return (
    <img
      src={src || variants[variant] || variants.fullLight}
      alt={alt}
      className={className}
      loading="eager"
      decoding="async"
    />
  )
}
